import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
    fetchData,
    fetchUpdateData,
    fetchDeleteData,
    fetchAllData,
} from "../../helpers/externapi";
import { Tabs, Tab, Box, } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import CommonTables from "../../Commoncomponents/CommonTables";
import TableContainer from "@mui/material/TableContainer";
import ConfirmationDialogDelete from "../../Components/ConfirmationDialogDelete";
import Paper from "@mui/material/Paper";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import Layout from "../../Layout/Layout";
import { fetchConfigValues, formatDate } from '../../Commoncomponents/CommonComponents';
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import DownloadIcon from '@mui/icons-material/Download';
import PeopleIcon from '@mui/icons-material/People';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import { TableSkeletonLoading } from "../../Commoncomponents/SkeletonLoading";




const customStyles = {
    header: {
        marginBottom: "10px",
        color: "#333",
    },
    addButton: {
        marginBottom: "20px",
        backgroundColor: "#4caf50",
    },
    tableContainer: {
        overflowX: "auto",
        marginBottom: "20px",
    },
    table: {
        width: "100%",
        borderCollapse: "collapse",
    },
    th: {
        border: "1px solid #ddd",
        padding: "8px",
        backgroundColor: "#f2f2f2",
        color: "#333",
    },
    td: {
        border: "1px solid #ddd",
        padding: "8px",
        color: "#333",
    },
    tdCenter: {
        border: "1px solid #ddd",
        padding: "8px",
        textAlign: "center",
        color: "#333",
    },
    loadingContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
    },
    buttonGroup: {
        display: "flex",
        marginBottom: "20px",
        gap: "10px",
    },
    container: { marginTop: "24px" },

    activeButton: { backgroundColor: "#1976d2", color: "#fff" },
    inactiveButton: { backgroundColor: "#e0e0e0", color: "#000" },
};

const StyledButton = styled(Button)(customStyles.addButton);

export default function List(props) {
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [communities, setCommunities] = useState([]);
    const [stateDropdown, setStatesDropdown] = useState([]);
    const [groups, setGroups] = useState([]);
    const [isEditMode, setIsEditMode] = useState(false);
    const [formVisible, setFormVisible] = useState(false);
    const [formErrors, setFormErrors] = useState({});
    const [formType, setFormType] = useState("state"); // 'state' or 'district'
    const [formData, setFormData] = useState({
        CommunityId: "",
        CommunityName: "",
        CommunityAddress: "",
        GroupId: "",
        GroupName: "",
        GroupLogo: "",
        GroupAddress: "",
        Name: "",
        DirectorName: "",
        ContactName: "",
        ContactNumber: "",
        ContactEmail: "",
        Designation: "",
        NoOfStaff: "",
        Area: "",
        Colony: "",
        Pincode: "",
        ExpiredDate: "",
    });
    const [totalCountGroups, setTotalCountGroups] = React.useState(0);
    const [currentPageDistrict, setCurrentPageDistrict] = React.useState(1);
    const [perPageDistrict, setPerPageDistrict] = React.useState(10);
    const [totalCountCommunity, setTotalCountCommunity] = React.useState(0);
    const [currentPageState, setCurrentPageState] = React.useState(1);
    const [perPageState, setPerPageState] = React.useState(10);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [confirmationOpen, setConfirmationOpen] = useState(false);
    const [confirmationData, setConfirmationData] = useState({});

    const [activeSection, setActiveSection] = useState("communities");
    const [searchLoading, setSearchLoading] = useState(false);
    const [input, setInput] = useState("");
    const [groupInput, setGroupInput] = useState("");
    const [selectedState, setSelectedState] = useState("");
    const [districtInput, setDistrictInput] = useState("");
    const [suggestions, setSuggestions] = useState([]);
    const [error, setError] = useState("");
    const [communitySuggestions, setCommunitySuggestions] = useState([]);

    const [districtFilterCriteria, setDistrictFilterCriteria] = useState([]);
    const [isDisableApply, setIsDisableApply] = useState(true);
    const [imageUrl, setImageUrl] = useState('');
    const [preview, setPreview] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [selectedGroups, setSelectedGroups] = useState([]);   // array of GroupId
    const [downloading, setDownloading] = useState(false);
    const [customerCounts, setCustomerCounts] = useState({});
    const [isActiveFilter, setIsActiveFilter] = useState(true);



    const handleOpen = () => setShowModal(true);
    const handleModalClose = () => setShowModal(false);

    const pdfRef = useRef(null);

    const handleDownload = async (group) => {
        try {
            const { jsPDF } = await import("jspdf");
            const html2canvas = (await import("html2canvas")).default;

            const hiResQR = await createHighResQRImage(group.QrCode.trim());

            // 1. Create hidden wrapper in DOM
            const wrapper = document.createElement("div");
            wrapper.style.cssText = "position: absolute; top: -9999px; left: -9999px;";
            wrapper.innerHTML = renderDownloadableMarkup(group);
            document.body.appendChild(wrapper);

            // 2. Inject high-res QR
            const qr = wrapper.querySelector('img[alt="QR Code"]');
            if (!qr) throw new Error("QR image not found");
            qr.src = hiResQR;
            qr.style.imageRendering = "pixelated";

            // 3. Wait for image to load
            await new Promise((resolve) => {
                qr.onload = resolve;
                if (qr.complete) resolve();
            });

            // 4. Get the element to snapshot
            const el = wrapper.querySelector("#downloadable-content");
            if (!el) throw new Error("#downloadable-content not found");

            const canvas = await html2canvas(el, {
                useCORS: true,
                allowTaint: true,
                scale: 2,
                backgroundColor: "#ffffff",
            });

            // Clean up
            document.body.removeChild(wrapper);

            // 5. Generate PDF
            const { width, height } = canvas;
            const pdf = new jsPDF({
                orientation: width > height ? "landscape" : "portrait",
                unit: "px",
                format: [width, height],
            });

            pdf.addImage(canvas, "PNG", 0, 0, width, height);
            pdf.save(`${group.GroupName}.pdf`);
        } catch (err) {
            console.error("Error generating PDF:", err);
        }
    };



    // Helper function to create high-resolution QR image
    const createHighResQRImage = (base64QR) => {
        return new Promise((resolve) => {
            const img = new Image();
            img.onload = () => {
                // Create a canvas to upscale the QR code
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');

                // Set canvas size to a higher resolution (multiply by 4)
                const size = Math.max(img.width, img.height) * 4;
                canvas.width = size;
                canvas.height = size;

                // Use nearest neighbor scaling to keep pixels sharp
                ctx.imageSmoothingEnabled = false;
                ctx.webkitImageSmoothingEnabled = false;
                ctx.mozImageSmoothingEnabled = false;
                ctx.msImageSmoothingEnabled = false;

                // Draw the image scaled up
                ctx.drawImage(img, 0, 0, size, size);

                resolve(canvas.toDataURL('image/png'));
            };
            img.src = `data:image/png;base64,${base64QR}`;
        });
    };

    const handleBulkDownload = async () => {
        if (!selectedGroups.length) return;

        setDownloading(true); // ⬅️ Start loading

        try {
            const { jsPDF } = await import("jspdf");
            const html2canvas = (await import("html2canvas")).default;

            let pdf;
            let isFirst = true;

            for (const id of selectedGroups) {
                const group = groups.find(g => g.GroupId === id);
                if (!group) continue;

                const wrapper = document.createElement("div");
                wrapper.style.cssText = "position:absolute;left:-9999px;top:-9999px;";
                wrapper.innerHTML = renderDownloadableMarkup(group);
                document.body.appendChild(wrapper);

                const qrImg = wrapper.querySelector('img[alt="QR Code"]');
                const hiResQR = await createHighResQRImage(group.QrCode);
                qrImg.src = hiResQR;
                qrImg.style.imageRendering = "pixelated";
                await new Promise(r => (qrImg.onload ? (qrImg.onload = r) : r()));

                const canvas = await html2canvas(wrapper.querySelector("#downloadable-content"), {
                    useCORS: true,
                    allowTaint: true,
                    scale: 2,
                    backgroundColor: "#ffffff",
                });

                document.body.removeChild(wrapper);

                const { width, height } = canvas;
                const imgData = canvas.toDataURL("image/png", 1.0);

                if (isFirst) {
                    pdf = new jsPDF({
                        orientation: width > height ? "landscape" : "portrait",
                        unit: "px",
                        format: [width, height],
                    });
                    isFirst = false;
                } else {
                    pdf.addPage([width, height]);
                    pdf.setPage(pdf.getNumberOfPages());
                }

                pdf.addImage(imgData, "PNG", 0, 0, width, height);
            }

            if (pdf) {
                pdf.save(`QRs_${new Date().toISOString().slice(0, 10)}.pdf`);
                setSelectedGroups([]); // clear selection
            }
        } catch (error) {
            console.error("Download error:", error);
        } finally {
            setDownloading(false); // ⬅️ Stop loading
        }
    };


    const renderDownloadableMarkup = (group) => `
  <div id="downloadable-content">
    <div class="text-center py-4" style="background-color:#00A3D9">
      <!-- OHO logo -->
      <div class="text-white mb-1">
        <img src="${process.env.PUBLIC_URL}/assets/ohowhitelogo.png" height="100" width="100" />
      </div>

      <!-- OHOINDIA -->
      <h3 class="fw-bold text-white fs-4 tracking-wide mb-0 font-rubik">
        OHOINDIA
      </h3>
    </div>

    <!-- QR Code section with side code -->
    <div class="bg-white p-4 position-relative">
      <!-- QR Code -->
      <img
        src="data:image/png;base64,${group.QrCode}"
        alt="QR Code"
        style="
          image-rendering:pixelated;
          width:100%;
          margin:0 auto;
          display:block;
        "
      />

      <!-- Side Code -->
      <div
        class="position-absolute top-50 translate-middle-y d-flex flex-column align-items-center"
        style="
          color:#00A3D9;
          right:-20px;
        "
      >
        <span
          class="fw-bold fs-5"
          style="
            transform:rotate(-90deg);
            transform-origin:center;
            white-space:nowrap;
          "
        >
          CODE&nbsp;:&nbsp;${group.Code || "ABC123"}
        </span>
      </div>
    </div>

    <div style="background-color:#00A3D9">
      <!-- Process steps -->
      <div class="d-flex justify-content-between px-4 py-3 text-center">
        <!-- Scan QR -->
        <div class="d-flex flex-column align-items-center" style="width:33%">
          ${svgScan()}
          <span class="text-white small mt-2">Scan the QR Code</span>
        </div>

        <!-- Enter Details -->
        <div class="d-flex flex-column align-items-center" style="width:33%">
          ${svgForm()}
          <span class="text-white small mt-2">Enter Your Details</span>
        </div>

        <!-- Registration Complete -->
        <div class="d-flex flex-column align-items-center" style="width:33%">
          ${svgCheck()}
          <span class="text-white small mt-2">Registration Completed</span>
        </div>
      </div>

      <!-- Contact info -->
      <div class="border-top border-white py-3">
        <div class="px-4">
          <div class="row g-4 align-items-center">
            <!-- Left: Title -->
            <div class="col-md-6 text-white fw-bold mb-3 text-center">
              For More Information
            </div>

            <!-- Right: Contact Info -->
            <div class="col-md-6 text-white small mb-3" style="padding-right:40px">
              <div class="d-flex flex-column align-items-start">
                <div class="mb-2" style="white-space:nowrap">
                  <span class="fw-semibold">Email:</span>
                  <span>contact@ohoindialife.com</span>
                </div>
                <div class="mb-2" style="white-space:nowrap">
                  <span class="fw-semibold">Contact&nbsp;No:</span>
                  <span>7032107108&nbsp;/&nbsp;7671997108</span>
                </div>
                <div style="white-space:nowrap">
                  <span class="fw-semibold">Website:</span>
                  <span>www.ohoindialife.com</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
`;

    /* ------------------------------------------------------------------ */
    /* Helper functions that return raw SVG markup.                       */
    /* Keeps the main template readable and avoids escaping problems.     */
    /* ------------------------------------------------------------------ */

    const svgScan = () => `
  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none"
       viewBox="0 0 24 24" stroke="currentColor" class="text-white">
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
          d="M7 2h10a2 2 0 012 2v6H5V4a2 2 0 012-2zM5 10h14v8a2 2 0 01-2 2H7a2 2 0 01-2-2v-8z"/>
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
          d="M9 14h1M9 16h1M12 14h1M12 16h1M15 14h1M15 16h1"/>
    <rect x="9" y="14" width="6" height="4" rx="1" fill="currentColor"
          class="text-white" opacity="0.2"/>
  </svg>
`;

    const svgForm = () => `
  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none"
       viewBox="0 0 24 24" stroke="currentColor" class="text-white">
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"/>
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M9 12h6m-6 4h6"/>
  </svg>
`;

    const svgCheck = () => `
  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none"
       viewBox="0 0 24 24" stroke="currentColor" class="text-white">
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
  </svg>
`;
















    const tableHeadsState = ["Community Name", "Community Address", "Created Date", "Actions"];
    const tableHeadsDistrict = ["Group Name", "Group Address", "Group Logo", "Code", "Name", "Director Name", "Created Date", "QR Code", "Dowload QR", "Customers", "Actions"];



    const tableElementsState = communities &&
        communities.length > 0
        ? communities.map((community) => [
            <Link
                to={
                    `/Communities/details/${community.CommunityId}`
                }
                className="text-start-important"
                style={{
                    whiteSpace: 'normal',
                    textAlign: 'start',
                    display: 'block',
                }}
            >
                {community.CommunityName}
            </Link>, community.CommunityAddress,
            formatDate(community.CreatedDate),

            <div style={{ display: "flex", alignItems: "center" }}>
                <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    style={{ marginRight: "10px" }}
                    onClick={() => handleEdit(community, "communities")}
                >
                    Edit
                </Button>
                <Button
                    variant="contained"
                    size="small"
                    sx={{
                        backgroundColor: "red",
                        color: "white",
                        "&:hover": { backgroundColor: "darkred" },
                    }}
                    onClick={() => handleDelete(community.CommunityId, "communities")}
                >
                    Delete
                </Button>
            </div >,
        ])
        : [];

    const tableElementsDistrict = groups && groups.length > 0
        ? groups.map((group, index) => {
            const modalId = `imagePreviewModal_${group.GroupId || index}`;
            const QRCodemodalId = `qrModal_${group.GroupId || index}`;

            const customerCount = customerCounts[group.GroupId] || 0;

            const customerCountCell = (
                <div style={{ textAlign: 'center' }}>
                    <Button
                        variant="contained"
                        size="small"
                        onClick={() => navigate(`/Communities/Group/customers/${group.GroupId}`)}
                        sx={{
                            backgroundColor: '#e3f2fd',
                            color: '#1976d2',
                            borderRadius: '16px',
                            padding: '4px 12px',
                            textTransform: 'none',
                            fontWeight: '500',
                            fontSize: '0.75rem',
                            '&:hover': {
                                backgroundColor: '#bbdefb'
                            }
                        }}
                        startIcon={<PeopleAltIcon fontSize="small" />}
                    >
                        {customerCount}
                    </Button>
                </div>
            );


            return [
                <Link
                    to={
                        `/Communities/Group/details/${group.GroupId}`
                    }
                    className="text-start-important"
                    style={{
                        whiteSpace: 'normal',
                        textAlign: 'start',
                        display: 'block',
                    }}
                >
                    {group.GroupName}
                </Link>,
                group.GroupAddress,
                <>
                    {/* Thumbnail image that opens modal */}
                    {imageUrl && group?.GroupLogo && (
                        <button
                            className="btn btn-link p-0"
                            data-bs-toggle="modal"
                            data-bs-target={`#${modalId}`} // no trailing space
                        >
                            <img
                                src={`${imageUrl}${group.GroupLogo} `}
                                alt="Small Group Logo"
                                style={{ width: '60px', height: '60px', objectFit: 'cover', borderRadius: '4px' }}
                            />
                        </button>
                    )}

                    {/* Bootstrap Modal with unique ID */}
                    <div
                        className="modal fade"
                        id={modalId}
                        tabIndex="-1"
                        aria-labelledby={`${modalId} -label`}
                        aria-hidden="true"
                    >
                        <div
                            className="modal-dialog modal-sm modal-dialog-centered"
                            style={{ maxWidth: '300px' }}
                        >
                            <div className="modal-content" style={{ backgroundColor: '#fff', borderRadius: '8px' }}>
                                <div className="modal-body d-flex justify-content-center align-items-center p-2">
                                    <img
                                        src={`${imageUrl}${group.GroupLogo} `}
                                        alt="Group Logo"
                                        style={{
                                            maxWidth: '100%',
                                            maxHeight: '250px',
                                            objectFit: 'contain',
                                            borderRadius: '4px'
                                        }}
                                    />
                                </div>
                                <div className="modal-footer justify-content-center p-2 pt-0 border-0">
                                    <button
                                        type="button"
                                        className="btn btn-sm btn-outline-secondary"
                                        data-bs-dismiss="modal"
                                    >
                                        Close
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </>,
                group.Code,
                <Link
                    to={
                        `/Communities/Group/details/${group.GroupId}`
                    }
                    className="text-start-important"
                    style={{
                        whiteSpace: 'normal',
                        textAlign: 'start',
                        display: 'block',
                    }}
                >
                    {group.Name}
                </Link>,
                group.DirectorName,
                formatDate(group.CreatedDate),
                <>
                    <td className="text-center">
                        {group.QrCode && (
                            <>
                                {/* QR thumbnail */}
                                <button
                                    className="btn btn-link p-0"
                                    data-bs-toggle="modal"
                                    data-bs-target={`#qrModal-${group.Code}`}
                                >
                                    <img
                                        src={`data:image/png;base64,${group.QrCode}`}
                                        style={{ width: '60px', height: '60px', objectFit: 'contain', borderRadius: '4px' }}
                                    />
                                </button>

                                {/* QR Modal */}
                                <div className="modal fade" id={`qrModal-${group.Code}`} tabIndex="-1" aria-hidden="true">
                                    <div className="modal-dialog modal-dialog-centered">
                                        <div className="modal-content p-0 rounded-3 overflow-hidden" ref={pdfRef}>
                                            {/* Blue header with OHO logo */}
                                            <div id="downloadable-content">
                                                <div className="text-center py-4" style={{ backgroundColor: "#00A3D9" }}>
                                                    {/* OHO logo */}
                                                    <div className="text-white mb-1">
                                                        <img src={`${process.env.PUBLIC_URL} /assets/ohowhitelogo.png`} height="100" width='100' />
                                                    </div>

                                                    {/* OHOINDIA */}
                                                    <h3 className="fw-bold text-white fs-4 tracking-wide mb-0 font-rubik">
                                                        OHOINDIA
                                                    </h3>

                                                </div>

                                                {/* QR Code section with side code */}
                                                <div className="bg-white p-4 position-relative">
                                                    {/* QR Code */}
                                                    <img
                                                        src={`data:image/png;base64,${group.QrCode}`}
                                                        alt="QR Code"
                                                        style={{
                                                            imageRendering: 'pixelated',
                                                            width: '100%',
                                                            // maxWidth: '250px',
                                                            margin: '0 auto',
                                                            display: 'block',
                                                        }}
                                                    />



                                                    {/* Side Code */}
                                                    <div
                                                        className="position-absolute top-50 translate-middle-y d-flex flex-column align-items-center"
                                                        style={{
                                                            color: "#00A3D9",
                                                            right: "-20px" // 👈 Pushes code away from the QR image
                                                        }}
                                                    >

                                                        <span
                                                            className="fw-bold fs-5"
                                                            style={{
                                                                transform: "rotate(-90deg)",
                                                                transformOrigin: "center",
                                                                whiteSpace: "nowrap",
                                                            }}
                                                        >
                                                            CODE : {group.Code || "ABC123"}
                                                        </span>
                                                    </div>

                                                </div>

                                                <div style={{ backgroundColor: "#00A3D9" }}>
                                                    {/* Process steps */}
                                                    <div className="d-flex justify-content-between px-4 py-3 text-center">
                                                        {/* Scan QR */}
                                                        <div className="d-flex flex-column align-items-center" style={{ width: "33%" }}>
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                width="40"
                                                                height="40"
                                                                fill="none"
                                                                viewBox="0 0 24 24"
                                                                stroke="currentColor"
                                                                className="text-white"
                                                            >
                                                                <path
                                                                    strokeLinecap="round"
                                                                    strokeLinejoin="round"
                                                                    strokeWidth="1.5"
                                                                    d="M7 2h10a2 2 0 012 2v6H5V4a2 2 0 012-2zM5 10h14v8a2 2 0 01-2 2H7a2 2 0 01-2-2v-8z"
                                                                />
                                                                <path
                                                                    strokeLinecap="round"
                                                                    strokeLinejoin="round"
                                                                    strokeWidth="1.5"
                                                                    d="M9 14h1M9 16h1M12 14h1M12 16h1M15 14h1M15 16h1"
                                                                />
                                                                <rect
                                                                    x="9"
                                                                    y="14"
                                                                    width="6"
                                                                    height="4"
                                                                    rx="1"
                                                                    fill="currentColor"
                                                                    className="text-white"
                                                                    opacity="0.2"
                                                                />
                                                            </svg>
                                                            <span className="text-white small mt-2">Scan the QR Code</span>
                                                        </div>


                                                        {/* Enter Details */}
                                                        <div className="d-flex flex-column align-items-center" style={{ width: "33%" }}>
                                                            <svg xmlns="http://www.w3.org/2000/svg" className="text-white" width="40" height="40" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6" />
                                                            </svg>
                                                            <span className="text-white small mt-2">Enter Your Details</span>
                                                        </div>

                                                        {/* Registration Complete */}
                                                        <div className="d-flex flex-column align-items-center" style={{ width: "33%" }}>
                                                            <svg xmlns="http://www.w3.org/2000/svg" className="text-white" width="40" height="40" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                                            </svg>
                                                            <span className="text-white small mt-2">Registration Completed</span>
                                                        </div>
                                                    </div>

                                                    {/* Contact info */}
                                                    <div className="border-top border-white py-3">
                                                        <div className="px-4">
                                                            <div className="row g-4 align-items-center">
                                                                {/* Left: Title */}
                                                                <div className="col-md-6 text-white fw-bold mb-3 text-center">
                                                                    For More Information
                                                                </div>

                                                                {/* Right: Contact Info aligned to the far right */}
                                                                <div className="col-md-6 text-white small mb-3" style={{ paddingRight: '40px' }}>
                                                                    <div className="d-flex flex-column align-items-start">
                                                                        <div className="mb-2" style={{ whiteSpace: 'nowrap' }}>
                                                                            <span className="fw-semibold me-2">Email:</span>
                                                                            <span>contact@ohoindialife.com</span>
                                                                        </div>
                                                                        <div className="mb-2" style={{ whiteSpace: 'nowrap' }}>
                                                                            <span className="fw-semibold me-2">Contact No:</span>
                                                                            <span>7032107108 / 7671997108</span>
                                                                        </div>
                                                                        <div style={{ whiteSpace: 'nowrap' }}>
                                                                            <span className="fw-semibold me-2">Website:</span>
                                                                            <span>www.ohoindialife.com</span>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>

                                            </div>


                                            {/* Close button */}
                                            <div className="bg-white py-3 text-center d-flex justify-content-center gap-3">
                                                <button
                                                    type="button"
                                                    className="btn btn-primary px-4 py-1"
                                                    onClick={() => handleDownload(group)}
                                                >
                                                    Download PDF
                                                </button>


                                                <button
                                                    type="button"
                                                    className="btn btn-outline-secondary px-4 py-1"
                                                    data-bs-dismiss="modal"
                                                >
                                                    Close
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </>
                        )}
                    </td>
                </>,
                // inside the map(), before the Edit/Delete buttons

                <>
                    {
                        group.QrCode && (
                            <td style={{ height: '100%', padding: 0 }}>
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        height: '100%',
                                        width: '100%',
                                    }}
                                >
                                    <input
                                        type="checkbox"
                                        checked={selectedGroups.includes(group.GroupId)}
                                        onChange={e => {
                                            setSelectedGroups(prev =>
                                                e.target.checked
                                                    ? [...prev, group.GroupId]
                                                    : prev.filter(id => id !== group.GroupId)
                                            );
                                        }}
                                        style={{
                                            width: '20px',
                                            height: '20px',
                                            cursor: 'pointer',
                                            marginLeft: '65px'
                                        }}
                                    />
                                </div>
                            </td>
                        )
                    }
                </>,
                customerCountCell,
                <div style={{ display: "flex", alignItems: "center" }}>
                    <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        style={{ marginRight: "10px" }}
                        onClick={() => handleEdit(group, "group")}
                    >
                        Edit
                    </Button>
                    {group.IsActive ? (
                        <Button
                            variant="contained"
                            size="small"
                            sx={{
                                backgroundColor: "red",
                                color: "white",
                                "&:hover": { backgroundColor: "darkred" },
                            }}
                            onClick={() => handleDelete(group.GroupId, "group")}
                        >
                            Delete
                        </Button>
                    ) : (
                        <Button
                            variant="contained"
                            size="small"
                            sx={{
                                backgroundColor: "green",
                                color: "white",
                                "&:hover": { backgroundColor: "darkred" },
                            }}
                            onClick={() => handleActivate(group.GroupId, "group")}
                        >
                            Activate
                        </Button>
                    )}

                </div>,
            ];
        })
        : [];


    useEffect(() => {
        const getMocUrl = async () => {
            const { userImagesBucketlink } = await fetchConfigValues();
            if (userImagesBucketlink) {
                setImageUrl(userImagesBucketlink);
            }
        };

        getMocUrl();
    }, []);


    const fetchCustomerCounts = async () => {
        try {
            const counts = {};
            await Promise.all(
                groups.map(async (group) => {
                    const response = await fetchAllData(
                        `lambdaAPI/CommunityCustomers/GetCountOfMembersByGroupId/${group.GroupId}`
                    );
                    counts[group.GroupId] = response.data || 0;
                })
            );
            setCustomerCounts(counts);
        } catch (error) {
            console.error("Error fetching customer counts:", error);
        }
    };

    // Call this after fetching groups

    useEffect(() => {
        if (groups.length > 0) {
            fetchCustomerCounts();
        }
    }, [groups]);

    const getCommunities = async () => {
        try {
            const skip = (currentPageState - 1) * perPageState;
            const take = perPageState;

            let statesData;

            setLoading(true);

            statesData = await fetchData("lambdaAPI/Community/all", { skip, take });

            setCommunities(statesData);
        } catch (error) {
            console.error("Error fetching states data:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const getStateDropdown = async () => {
            try {
                setLoading(true);

                const statesData = await fetchData("States/all", { skip: 0, take: 0 });
                setStatesDropdown(statesData);
            } catch (error) {
                console.error("Error fetching states data:", error);
            } finally {
                setLoading(false);
            }
        };
        getStateDropdown();
    }, []);

    const getGroups = async (isActive) => {
        try {
            const skip = (currentPageDistrict - 1) * perPageDistrict;
            const take = perPageDistrict;

            setLoading(true);

            const districtsData = await fetchData("lambdaAPI/Group/all", {
                skip,
                take,
                isActive, // pass true or false
            });

            setGroups(districtsData);
        } catch (error) {
            console.error("Error fetching district data:", error);
        } finally {
            setLoading(false);
        }
    };


    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setPreview(URL.createObjectURL(file)); // Temporary image preview
        }
        handleLogoChange(e); // Call parent's handler
    };


    const handleLogoChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64String = reader.result.split(',')[1]; // Remove "data:image/...;base64,"
                setFormData((prevData) => ({
                    ...prevData,
                    GroupLogo: base64String
                }));
            };
            reader.readAsDataURL(file);
        }
    };


    useEffect(() => {
        getCommunities();
        getGroups(isActiveFilter);
    }, [
        currentPageDistrict,
        perPageDistrict,
        currentPageState,
        perPageState,
        isActiveFilter,
    ]);

    useEffect(() => {
        getGroupsCountData(isActiveFilter);
        getCommunityCountData();
    }, [isActiveFilter]);

    const onChangeHandler = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleEdit = (item, type) => {
        setIsEditMode(true);
        setFormVisible(true);
        setFormType(type);
        if (type === "communities") {
            setFormData({
                CommunityId: item.CommunityId,
                CommunityName: item.CommunityName,
                CommunityAddress: item.CommunityAddress,
                GroupId: "",
                GroupName: "",
                GroupLogo: "",
                GroupAddress: "",
                Name: "",
                DirectorName: "",
                DirectorName: "",
                ContactName: "",
                ContactNumber: "",
                ContactEmail: "",
                Designation: "",
                NoOfStaff: "",
                Area: "",
                Colony: "",
                Pincode: ""
            });
        } else {
            setFormData({
                GroupId: item.GroupId,
                GroupName: item.GroupName,
                GroupLogo: item.GroupLogo,
                GroupAddress: item.GroupAddress,
                Name: item.Name,
                DirectorName: item.DirectorName,
                ContactName: item.ContactName,
                ContactNumber: item.ContactNumber,
                ContactEmail: item.Email,
                Designation: item.Designation,
                NoOfStaff: item.NoOfStaff,
                Area: item.Area,
                Colony: item.Colony,
                Pincode: item.Pincode,
                ExpiredDate: item.ExpiredDate,
            });
        }
    };

    const handleSnackbarClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setSnackbarOpen(false);
    };

    const handleAddNew = (type) => {
        setIsEditMode(false);
        setFormVisible(true);
        setFormType(type);
        setFormData({
            CommunityId: "",
            CommunityName: "",
            CommunityAddress: "",
            GroupId: "",
            GroupName: "",
            GroupLogo: "",
            GroupAddress: "",
            Name: "",
            DirectorName: "",
            DirectorName: "",
            ContactName: "",
            ContactNumber: "",
            ContactEmail: "",
            Designation: "",
            NoOfStaff: "",
            Area: "",
            Colony: "",
            Pincode: "",
            ExpiredDate: "",
        });
    };

    const validateForm = () => {
        let valid = true;
        const errors = {};

        if (formType === "communities") {
            if (!formData.CommunityName.trim()) {
                errors.CommunityName = "Please enter Community Name";
                valid = false;
            }
        } else {
            if (!formData.Name.trim()) {
                errors.Name = "Please enter Name";
                valid = false;
            }

            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

            if (formData.ContactEmail && !emailRegex.test(formData.ContactEmail)) {
                errors.ContactEmail = "Please enter a valid email";
                valid = false;
            }

        }

        setFormErrors(errors);
        return valid;
    };


    const handleUpload = async (groupId) => {
        if (!formData.GroupLogo || !groupId) {
            alert("GroupId or logo missing");
            return;
        }

        const payload = {
            GroupId: groupId,
            GroupLogo: formData.GroupLogo,
        };

        try {
            const response = await fetchData('lambdaAPI/Group/CompanyImage',
                payload,
            );

            const result = await response.json();
        } catch (error) {
            console.error('Upload failed:', error);
        }
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            if (validateForm()) {
                if (formType === "communities") {
                    if (isEditMode) {

                        const communityUpdateData = [
                            {
                                columnName: "CommunityName",
                                columnValue: formData.CommunityName,
                                tableName: "Community",
                                tableId: formData.CommunityId
                            },
                            {
                                columnName: "CommunityAddress",
                                columnValue: formData.CommunityAddress,
                                tableName: "Community",
                                tableId: formData.CommunityId,
                            }
                        ];

                        const EditData = await fetchUpdateData(
                            "lambdaAPI/Update/CommonUpdate",
                            communityUpdateData
                        );


                        // await fetchUpdateData("lambdaAPI/Community/update", {
                        //   communityId: formData.CommunityId,
                        //   communityName: formData.CommunityName,
                        //   communityAddress: formData.CommunityAddress
                        // });
                        setSnackbarMessage("Community updated successfully!");
                    } else {
                        await fetchData("lambdaAPI/Community/add", {
                            communityName: formData.CommunityName,
                            communityAddress: formData.CommunityAddress
                        });
                        setSnackbarMessage("Community added successfully!");
                    }
                    setSnackbarOpen(true);
                    await getCommunities();
                } else {
                    if (isEditMode) {
                        const groupUpdateData = [
                            {
                                columnName: "GroupName",
                                columnValue: formData.GroupName,
                                tableName: "Group",
                                tableId: formData.GroupId
                            },
                            {
                                columnName: "GroupAddress",
                                columnValue: formData.GroupAddress,
                                tableName: "Group",
                                tableId: formData.GroupId,
                            },
                            {
                                columnName: "Name",
                                columnValue: formData.Name,
                                tableName: "Group",
                                tableId: formData.GroupId,
                            },
                            {
                                columnName: "DirectorName",
                                columnValue: formData.DirectorName,
                                tableName: "Group",
                                tableId: formData.GroupId,
                            },
                            {
                                columnName: "ContactName",
                                columnValue: formData.ContactName,
                                tableName: "Group",
                                tableId: formData.GroupId,
                            },
                            {
                                columnName: "ContactNumber",
                                columnValue: formData.ContactNumber,
                                tableName: "Group",
                                tableId: formData.GroupId,
                            },
                            {
                                columnName: "Email",
                                columnValue: formData.ContactEmail,
                                tableName: "Group",
                                tableId: formData.GroupId,
                            },
                            {
                                columnName: "Designation",
                                columnValue: formData.Designation,
                                tableName: "Group",
                                tableId: formData.GroupId,
                            },
                            {
                                columnName: "NoOfStaff",
                                columnValue: formData.NoOfStaff,
                                tableName: "Group",
                                tableId: formData.GroupId,
                            },
                            {
                                columnName: "Area",
                                columnValue: formData.Area,
                                tableName: "Group",
                                tableId: formData.GroupId,
                            },
                            {
                                columnName: "Colony",
                                columnValue: formData.Colony,
                                tableName: "Group",
                                tableId: formData.GroupId,
                            },
                            {
                                columnName: "Pincode",
                                columnValue: formData.Pincode,
                                tableName: "Group",
                                tableId: formData.GroupId,
                            },
                            {
                                columnName: "ExpiredDate",
                                columnValue: formData.ExpiredDate,
                                tableName: "Group",
                                tableId: formData.GroupId,
                            }
                        ];

                        const EditData = await fetchUpdateData(
                            "lambdaAPI/Update/CommonUpdate",
                            groupUpdateData
                        );

                        const groupId = formData.GroupId;

                        if (groupId && formData.GroupLogo) {
                            await handleUpload(groupId);
                        }
                        setSnackbarMessage("Group updated successfully!");

                    } else {
                        const groupAdd = await fetchData("lambdaAPI/Group/add", {
                            groupName: formData.GroupName,
                            //groupLogo: formData.GroupLogo,
                            groupAddress: formData.GroupAddress,
                            name: formData.Name,
                            directorName: formData.DirectorName,
                            contactName: formData.ContactName,
                            contactNumber: formData.ContactNumber,
                            email: formData.ContactEmail,
                            designation: formData.Designation,
                            area: formData.Area,
                            colony: formData.Colony,
                            pincode: formData.Pincode,
                            ExpiredDate: formData.ExpiredDate,
                        });

                        const groupId = groupAdd?.data?.groupId;

                        if (groupId && formData.GroupLogo) {
                            await handleUpload(groupId);
                        }
                        setSnackbarMessage("Group added successfully!");
                    }
                    setSnackbarOpen(true);
                    await getGroups(isActiveFilter);
                }
                setFormVisible(false);
                setFormData({
                    CommunityId: "",
                    CommunityName: "",
                    CommunityAddress: "",
                    GroupId: "",
                    GroupName: "",
                    GroupAddress: "",
                    GroupLogo: "",
                    Name: "",
                    DirectorName: "",
                    DirectorName: "",
                    ContactName: "",
                    ContactNumber: "",
                    ContactEmail: "",
                    Designation: "",
                    NoOfStaff: "",
                    Area: "",
                    Colony: "",
                    Pincode: "",
                    ExpiredDate: "",
                });
            }
        } catch (error) {
            console.error("Error adding/updating item:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleActivate = (id, type) => {
        setConfirmationData({
            title: "Activate Group",
            message: "Are you sure you want to Activate this Group?",
            onConfirm: () => confirmhandleActivate(id, type),
        });
        setConfirmationOpen(true);
    };

    const handleDelete = (id, type) => {
        setConfirmationData({
            title: "Delete Community Or Group",
            message: "Are you sure you want to delete this Community or Group?",
            onConfirm: () => confirmhandleDelete(id, type),
        });
        setConfirmationOpen(true);
    };

    const confirmhandleActivate = async (id, type) => {
        try {
            setLoading(true);
            setConfirmationOpen(false);

            const updatePayload =
                [
                    {
                        columnName: "IsActive",
                        columnValue: 1,
                        tableName: "Group",
                        tableId: id,
                    },
                ];

            await fetchUpdateData("lambdaAPI/Update/CommonUpdate", updatePayload);
            await getGroups(isActiveFilter);
            setSnackbarMessage("Group Activated Successfully");
            setSnackbarOpen(true);
        } catch (error) {
            console.error("Error Activating Group:", error);
        } finally {
            setLoading(false);
        }
    };

    const confirmhandleDelete = async (id, type) => {
        try {
            setLoading(true);
            setConfirmationOpen(false);
            if (type === "communities") {
                await fetchDeleteData(`lambdaAPI/Community/delete/${id}`);
                await getCommunities();
                setSnackbarMessage("Community deleted Successfully");
                setSnackbarOpen(true);
            } else {
                await fetchDeleteData(`lambdaAPI/Group/delete/${id}`);
                await getGroups();
                setSnackbarMessage("Group deleted Successfully");
                setSnackbarOpen(true);
            }
        } catch (error) {
            console.error("Error deleting item:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => {
        setFormVisible(false);
        setFormData({
            CommunityId: "",
            CommunityName: "",
            CommunityAddress: "",
            GroupId: "",
            GroupName: "",
            GroupAddress: "",
            GroupLogo: "",
            Name: "",
            DirectorName: "",
            DirectorName: "",
            ContactName: "",
            ContactNumber: "",
            ContactEmail: "",
            Designation: "",
            NoOfStaff: "",
            Area: "",
            Colony: "",
            Pincode: ""
        });
    };

    const getGroupsCountData = async (isActive) => {
        setLoading(true);
        try {
            const districtCountData = await fetchData(
                `CommonRowCount/GetTableRowCount`,
                { tableName: "`Group`", isActive }
            );
            const totalCount = districtCountData[0]?.CountOfRecords || 0;
            setTotalCountGroups(totalCount);
            setLoading(false);
        } catch (error) {
            console.error("Error fetching hospital count data:", error);
            setLoading(false);
        }
    };

    const getCommunityCountData = async () => {
        setLoading(true);
        try {
            const stateCountData = await fetchData(
                `CommonRowCount/GetTableRowCount`,
                { tableName: "Community" }
            );
            const totalCount = stateCountData[0]?.CountOfRecords || 0;
            setTotalCountCommunity(totalCount);
            setLoading(false);
        } catch (error) {
            console.error("Error fetching hospital count data:", error);
            setLoading(false);
        }
    };

    const handlePageChangeDistrict = (event, page) => {
        setCurrentPageDistrict(page);
    };

    const handlePerPageChangeDistrict = (event) => {
        setPerPageDistrict(parseInt(event.target.value, 10));
        setCurrentPageDistrict(1);
    };

    const handlePageChangeState = (event, page) => {
        setCurrentPageState(page);
    };

    const handlePerPageChangeState = (event) => {
        setPerPageState(parseInt(event.target.value, 10));
        setCurrentPageState(1);
    };

    const handleInputChange = async (event) => {
        const value = event.target.value;
        setInput(value);

        if (value.length > 0) {
            const filterCriteria = [];

            filterCriteria.push({
                key: "CommunityName",
                value: value,
                operator: "LIKE",
            });

            setSearchLoading(true);
            setError("");
            try {

                const suggestionData = await fetchData("lambdaAPI/Community/GetCommunityMultipleDataByName", {
                    skip: 0,
                    take: perPageState,
                    filter: filterCriteria
                });

                setCommunitySuggestions(suggestionData);


            } catch (error) {
                console.error(error);
            } finally {
                setSearchLoading(false);
            }
        } else {
            setCommunitySuggestions([]);
        }
    };



    const clearSearch = async () => {
        setInput("");
        setCommunitySuggestions([]);
    };

    const handleGroupInputChange = async (event) => {
        const value = event.target.value;
        setGroupInput(value);

        if (value.length >= 2) {
            setSearchLoading(true);
            setError('');
            setSuggestions([]);

            try {
                // First try with GroupName
                let filterCriteria = [{
                    key: "GroupName",
                    value: value,
                    operator: "LIKE"
                }];

                let suggestionData = await fetchData("lambdaAPI/Group/GetGroupMultipleDataByName", {
                    skip: 0,
                    take: 10,
                    filter: filterCriteria
                });

                // If no result, fallback to Name
                if (suggestionData.length === 0) {
                    filterCriteria = [{
                        key: "Name",
                        value: value,
                        operator: "LIKE"
                    }];

                    suggestionData = await fetchData("lambdaAPI/Group/GetGroupMultipleDataByName", {
                        skip: 0,
                        take: 10,
                        filter: filterCriteria
                    });
                }

                if (suggestionData.length > 0) {
                    setSuggestions(suggestionData);
                } else {
                    setError('No suggestions found.');
                }

            } catch (error) {
                setError('Failed to fetch suggestions.');
            } finally {
                setSearchLoading(false);
            }

        } else {
            setSuggestions([]);
        }
    };



    const clearGroupSearch = () => {
        setGroupInput('');
        setSuggestions([]);
    };

    useEffect(() => {
        if (districtInput === "") {
            setIsDisableApply(true);
        } else {
            setIsDisableApply(false);
        }
    }, [selectedState, districtInput]);




    const handleSuggestionClick = (suggestion) => {
        navigate(`/Communities/Group/details/${suggestion.GroupId}`);
    };

    const handleCommunitySuggestionClick = (suggestion) => {
        navigate(`/Communities/details/${suggestion.CommunityId}`);
    }


    return (
        <>
            {loading && TableSkeletonLoading()}
            {!loading && (
                <>
                    <div style={customStyles.container}>
                        <Box style={customStyles.buttonGroup}>
                            <Button
                                variant="contained"
                                style={
                                    activeSection === "communities"
                                        ? customStyles.activeButton
                                        : customStyles.inactiveButton
                                }
                                onClick={() => setActiveSection("communities")}
                            >
                                Communities
                            </Button>
                            <Button
                                variant="contained"
                                style={
                                    activeSection === "groups"
                                        ? customStyles.activeButton
                                        : customStyles.inactiveButton
                                }
                                onClick={() => setActiveSection("groups")}
                            >
                                Groups
                            </Button>
                        </Box>

                        {activeSection === "communities" && (
                            <div>
                                {/* State List Header */}
                                <h2 style={{ ...customStyles.header, marginBottom: "5px" }}>
                                    Community List
                                </h2>

                                {/* Search & Add State Container */}
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "10px", // Reduced from 20px to 10px
                                        marginBottom: "5px", // Reduced from 10px to 5px
                                    }}
                                >
                                    {/* Search Input */}
                                    <div
                                        style={{
                                            position: "relative",
                                            maxWidth: "250px",
                                            flexGrow: 1,
                                        }}
                                    >
                                        <i
                                            className="fas fa-search"
                                            style={{
                                                position: "absolute",
                                                left: "10px",
                                                top: "50%",
                                                transform: "translateY(-50%)",
                                                fontSize: "14px",
                                                color: "#6c757d",
                                            }}
                                        ></i>

                                        <input
                                            type="text"
                                            id="search-input"
                                            className="form-control"
                                            style={{
                                                width: "100%",
                                                height: "38px",
                                                fontSize: "14px",
                                                paddingLeft: "30px",
                                            }}
                                            maxLength="50"
                                            value={input}
                                            onChange={handleInputChange}
                                            placeholder="Enter Community Name"
                                        />

                                        {input && (
                                            <i
                                                className="fas fa-times-circle"
                                                style={{
                                                    position: "absolute",
                                                    right: "10px",
                                                    top: "50%",
                                                    transform: "translateY(-50%)",
                                                    fontSize: "16px",
                                                    color: "red",
                                                    cursor: "pointer",
                                                }}
                                                onClick={clearSearch}
                                            ></i>
                                        )}

                                        {searchLoading && (
                                            <div
                                                style={{
                                                    position: "absolute",
                                                    right: "40px",
                                                    top: "50%",
                                                    transform: "translateY(-50%)",
                                                }}
                                            >
                                                <div
                                                    className="spinner-border text-primary"
                                                    role="status"
                                                    style={{ width: "1.5rem", height: "1.5rem" }}
                                                >
                                                    <span className="visually-hidden">Loading...</span>
                                                </div>
                                            </div>
                                        )}

                                        {/* Suggestions Dropdown */}
                                        {input && !searchLoading && communitySuggestions.length > 0 && (
                                            <ul
                                                style={{
                                                    listStyleType: "none",
                                                    padding: "0",
                                                    margin: "0",
                                                    border: "1px solid #00796b",
                                                    borderRadius: "4px",
                                                    maxHeight: "200px",
                                                    overflowY: "auto",
                                                    position: "absolute",
                                                    width: "100%",
                                                    backgroundColor: "#fff",
                                                    zIndex: 10,
                                                    top: "100%",
                                                    left: "0",
                                                }}
                                            >
                                                {communitySuggestions.map((community, index) => (
                                                    <li
                                                        key={index}
                                                        onClick={() => handleCommunitySuggestionClick(community)}
                                                        style={{
                                                            padding: "8px",
                                                            cursor: "pointer",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            borderBottom: "1px solid #eee",
                                                        }}
                                                    >
                                                        <i
                                                            className="fas fa-map-marker-alt"
                                                            style={{ marginRight: "8px", color: "#00796b" }}
                                                        ></i>
                                                        <span>{community.CommunityName}</span>
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>


                                    {/* Add State Button */}
                                    {/* <StyledButton
        variant="contained"
        color="primary"
        onClick={() => handleAddNew("state")}
        style={{
          height: "38px", // Reduced height slightly
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "0 12px", // Slightly reduced padding
          fontSize: "14px",
          marginTop:"18px"
        }}
      >
        Add State
      </StyledButton> */}
                                    <button
                                        className="btn btn-secondary mt-2 "
                                        onClick={() => handleAddNew("communities")}
                                        style={{
                                            height: "40px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            backgroundColor: "#28a745",
                                            fontSize: "14px",
                                        }}
                                    >
                                        Add Community
                                    </button>
                                </div>

                                <div className="card">
                                    {communities && communities.length > 0 && (
                                        <CommonTables
                                            tableHeads={tableHeadsState}
                                            tableData={tableElementsState}
                                            perPage={perPageState}
                                            currentPage={currentPageState}
                                            perPageChange={handlePerPageChangeState}
                                            pageChange={handlePageChangeState}
                                            totalCount={totalCountCommunity}
                                        />
                                    )}
                                </div>

                                {/* No Records Message */}
                                {!loading && communities.length === 0 && (
                                    <h5
                                        className="text-danger"
                                        style={{ textAlign: "center", padding: "10px" }}
                                    >
                                        There are no records to display.
                                    </h5>
                                )}
                            </div>
                        )}

                        {activeSection === "groups" && (
                            <div>
                                <h2 style={customStyles.header}>Groups List</h2>

                                <div className="mb-3">
                                    <button
                                        className={`btn me-2 ${isActiveFilter ? "btn-primary" : "btn-outline-primary"}`}
                                        onClick={() => setIsActiveFilter(true)}
                                    >
                                        Active
                                    </button>
                                    <button
                                        className={`btn ${!isActiveFilter ? "btn-danger" : "btn-outline-danger"}`}
                                        onClick={() => setIsActiveFilter(false)}
                                    >
                                        Inactive
                                    </button>
                                </div>



                                <div className="row align-items-end">
                                    {/* Search Input */}
                                    <div className="col-12 col-md-5 mb-3">
                                        <label htmlFor="search-input" className="form-label">Group Name or Name</label>
                                        <div style={{ position: 'relative', maxWidth: '100%' }}>
                                            <input
                                                type="text"
                                                id="search-input"
                                                className="form-control"
                                                style={{ paddingLeft: '30px' }}
                                                maxLength="50"
                                                value={groupInput}
                                                onChange={handleGroupInputChange}
                                            />
                                            {groupInput && (
                                                <i
                                                    className="fas fa-times-circle"
                                                    style={{
                                                        position: 'absolute',
                                                        right: '10px',
                                                        top: '50%',
                                                        transform: 'translateY(-50%)',
                                                        fontSize: '16px',
                                                        color: 'red',
                                                        cursor: 'pointer'
                                                    }}
                                                    onClick={clearGroupSearch}
                                                ></i>
                                            )}
                                            {searchLoading && (
                                                <div
                                                    style={{
                                                        position: 'absolute',
                                                        right: '40px',
                                                        top: '50%',
                                                        transform: 'translateY(-50%)'
                                                    }}
                                                >
                                                    <div className="spinner-border text-primary" role="status" style={{ width: '1.5rem', height: '1.5rem' }}>
                                                        <span className="visually-hidden">Loading...</span>
                                                    </div>
                                                </div>
                                            )}

                                            {groupInput && !searchLoading && suggestions.length > 0 && (
                                                <ul
                                                    style={{
                                                        listStyleType: 'none',
                                                        padding: '0',
                                                        margin: '0',
                                                        border: '1px solid #00796b',
                                                        borderRadius: '4px',
                                                        maxHeight: '200px',
                                                        overflowY: 'auto',
                                                        position: 'absolute',
                                                        width: '100%',
                                                        backgroundColor: '#fff',
                                                        zIndex: 10,
                                                        top: '100%',
                                                        left: '0'
                                                    }}
                                                >
                                                    {suggestions.map((suggestion, index) => (
                                                        <li
                                                            key={index}
                                                            onClick={() => handleSuggestionClick(suggestion)}
                                                            style={{
                                                                padding: '8px',
                                                                cursor: 'pointer',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                position: 'relative'
                                                            }}
                                                        >
                                                            <i className="fas fa-arrow-up-left" style={{ marginRight: '8px', color: '#00796b' }}></i>
                                                            <span style={{ flex: 1 }}>{suggestion.Concatenated}</span>
                                                        </li>
                                                    ))}
                                                </ul>
                                            )}

                                            {groupInput && !searchLoading && error && (
                                                <div
                                                    style={{
                                                        position: 'absolute',
                                                        top: '100%',
                                                        left: '0',
                                                        color: 'red',
                                                        fontSize: '0.9rem',
                                                        marginTop: '4px',
                                                        backgroundColor: '#fff',
                                                        border: '1px solid #00796b',
                                                        borderRadius: '4px',
                                                        padding: '8px',
                                                        zIndex: 10,
                                                        width: '100%'
                                                    }}
                                                >
                                                    {error}
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {/* Add Group Button */}
                                    <div className="col-6 col-md-2 mb-3 d-flex justify-content-center">
                                        <button
                                            className="btn btn-success w-100"
                                            onClick={() => handleAddNew("groups")}
                                            style={{ height: "40px" }}
                                        >
                                            Add Group
                                        </button>
                                    </div>

                                    {/* Download Button */}
                                    <div className="col-6 col-md-5 mb-3 d-flex justify-content-md-end justify-content-center">
                                        <Button
                                            variant="contained"
                                            color="success"
                                            disabled={selectedGroups.length === 0 || downloading}
                                            onClick={handleBulkDownload}
                                            endIcon={
                                                downloading ? (
                                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                ) : (
                                                    <DownloadIcon />
                                                )
                                            }
                                        >
                                            {downloading ? "Downloading..." : `Download ${selectedGroups.length} QRs`}
                                        </Button>
                                    </div>
                                </div>

                                <div className="card">
                                    {groups && groups.length > 0 && (
                                        <CommonTables
                                            tableHeads={tableHeadsDistrict}
                                            tableData={tableElementsDistrict}
                                            perPage={perPageDistrict}
                                            currentPage={currentPageDistrict}
                                            perPageChange={handlePerPageChangeDistrict}
                                            pageChange={handlePageChangeDistrict}
                                            totalCount={totalCountGroups}
                                        />
                                    )}
                                </div>

                                {!loading && groups.length === 0 && (
                                    <h5
                                        className="text-danger"
                                        style={{ textAlign: "center", padding: "20px" }}
                                    >
                                        There are no records to display.
                                    </h5>
                                )}
                            </div>
                        )}

                        <TableContainer component={Paper}>
                            <ConfirmationDialogDelete
                                open={confirmationOpen}
                                title={confirmationData.title}
                                message={confirmationData.message}
                                onConfirm={confirmationData.onConfirm}
                                onCancel={() => setConfirmationOpen(false)}
                            />
                            <Snackbar
                                open={snackbarOpen}
                                autoHideDuration={6000}
                                onClose={handleSnackbarClose}
                                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                            >
                                <Alert onClose={handleSnackbarClose} severity="success">
                                    {snackbarMessage}
                                </Alert>
                            </Snackbar>
                        </TableContainer>
                        <Dialog
                            open={formVisible}
                            onClose={handleClose}
                            aria-labelledby="form-dialog-title"
                        >
                            <DialogTitle id="form-dialog-title">
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                    }}
                                >
                                    <Typography variant="h6">
                                        {isEditMode
                                            ? formType === "communities"
                                                ? "Update Community"
                                                : "Update Group"
                                            : formType === "communities"
                                                ? "Add Community"
                                                : "Add Group"}
                                    </Typography>
                                    <IconButton onClick={handleClose} style={{ color: "red" }}>
                                        ✖
                                    </IconButton>
                                </div>
                            </DialogTitle>
                            <DialogContent>
                                <DialogContentText>
                                    {isEditMode
                                        ? formType === "communities"
                                            ? "Update the details of the community."
                                            : "Update the details of the group."
                                        : formType === "communities"
                                            ? "Fill in the details of the new community."
                                            : "Fill in the details of the new group."}
                                </DialogContentText>
                                <form noValidate autoComplete="off">
                                    {formType === "communities" ? (
                                        <>
                                            <TextField
                                                name="CommunityName"
                                                label={
                                                    <Typography component="span">
                                                        Community Name <span style={{ color: 'red' }}>*</span>
                                                    </Typography>
                                                }
                                                value={formData.CommunityName}
                                                onChange={onChangeHandler}
                                                variant="outlined"
                                                size="small"
                                                fullWidth
                                                margin="normal"
                                                error={!!formErrors.CommunityName}
                                                helperText={formErrors.CommunityName}
                                            />
                                            <TextField
                                                name="CommunityAddress"
                                                label="Community Address"
                                                value={formData.CommunityAddress}
                                                onChange={onChangeHandler}
                                                variant="outlined"
                                                size="small"
                                                fullWidth
                                                margin="normal"
                                            />
                                        </>
                                    ) : (
                                        <>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label className="form-label">Group Name </label>
                                                    <input
                                                        type="text"
                                                        name="GroupName"
                                                        className="form-control"
                                                        value={formData.GroupName}
                                                        onChange={onChangeHandler}
                                                        placeholder="Enter group name"
                                                    />

                                                </div>
                                            </div>

                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label className="form-label">Group Address </label>
                                                    <input
                                                        type="text"
                                                        name="GroupAddress"
                                                        className="form-control"
                                                        value={formData.GroupAddress}
                                                        onChange={onChangeHandler}
                                                        placeholder="Enter group address"
                                                    />

                                                </div>
                                            </div>

                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label className="form-label">Director Name </label>
                                                    <input
                                                        type="text"
                                                        name="DirectorName"
                                                        className="form-control"
                                                        value={formData.DirectorName}
                                                        onChange={onChangeHandler}
                                                        placeholder="Enter Director Name"
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-md-12">
                                                <div className="form-group">

                                                    {(preview || (imageUrl && formData?.GroupLogo)) && (
                                                        <div className="mt-2">
                                                            <img
                                                                src={
                                                                    preview ||
                                                                    (typeof formData.GroupLogo === 'string'
                                                                        ? `${imageUrl}${formData.GroupLogo}`
                                                                        : '')
                                                                }
                                                                alt="Group Logo Preview"
                                                                style={{
                                                                    width: '64px',
                                                                    height: '64px',
                                                                    objectFit: 'cover',
                                                                    borderRadius: '8px',
                                                                    border: '1px solid #ccc'
                                                                }}
                                                            />
                                                        </div>
                                                    )}
                                                    <label className="form-label">
                                                        Group Logo
                                                    </label>
                                                    <input
                                                        type="file"
                                                        name="GroupLogo"
                                                        className="form-control"
                                                        accept="image/*"
                                                        onChange={handleFileChange}
                                                    />




                                                </div>
                                            </div>

                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label className="form-label">Name <span className="text-danger">*</span></label>
                                                    <input
                                                        type="text"
                                                        name="Name"
                                                        className="form-control"
                                                        value={formData.Name}
                                                        onChange={onChangeHandler}
                                                        placeholder="Enter name"
                                                    />
                                                    {formErrors.Name && (
                                                        <Typography variant="caption" color="error">
                                                            {formErrors.Name}
                                                        </Typography>
                                                    )}
                                                </div>
                                            </div>

                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label className="form-label">Contact Name</label>
                                                    <input
                                                        type="text"
                                                        name="ContactName"
                                                        className="form-control"
                                                        value={formData.ContactName}
                                                        onChange={onChangeHandler}
                                                        placeholder="Enter contact name"
                                                    />

                                                </div>
                                            </div>

                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label className="form-label">Contact Number</label>
                                                    <input
                                                        type="text"
                                                        name="ContactNumber"
                                                        className="form-control"
                                                        value={formData.ContactNumber}
                                                        onChange={(e) => {
                                                            const val = e.target.value;
                                                            if (/^\d{0,10}$/.test(val)) {
                                                                onChangeHandler(e);
                                                            }
                                                        }}
                                                        placeholder="Enter contact number"
                                                        maxLength="10"
                                                    />


                                                </div>
                                            </div>

                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label className="form-label">Contact Email</label>
                                                    <input
                                                        type="email"
                                                        name="ContactEmail"
                                                        className="form-control"
                                                        value={formData.ContactEmail}
                                                        onChange={onChangeHandler}
                                                        placeholder="Enter contact email"
                                                    />
                                                    {formErrors.ContactEmail && (
                                                        <Typography variant="caption" color="error">
                                                            {formErrors.ContactEmail}
                                                        </Typography>
                                                    )}


                                                </div>
                                            </div>

                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label className="form-label">Designation</label>
                                                    <input
                                                        type="text"
                                                        name="Designation"
                                                        className="form-control"
                                                        value={formData.Designation}
                                                        onChange={onChangeHandler}
                                                        placeholder="Enter designation"
                                                    />

                                                </div>
                                            </div>

                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label className="form-label">No. of Staff</label>
                                                    <input
                                                        type="number"
                                                        name="NoOfStaff"
                                                        className="form-control"
                                                        value={formData.NoOfStaff}
                                                        onChange={onChangeHandler}
                                                        placeholder="Enter Staff Total Count"
                                                    />

                                                </div>
                                            </div>

                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label className="form-label">Area</label>
                                                    <input
                                                        type="text"
                                                        name="Area"
                                                        className="form-control"
                                                        value={formData.Area}
                                                        onChange={onChangeHandler}
                                                        placeholder="Enter area"
                                                    />

                                                </div>
                                            </div>

                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label className="form-label">Colony</label>
                                                    <input
                                                        type="text"
                                                        name="Colony"
                                                        className="form-control"
                                                        value={formData.Colony}
                                                        onChange={onChangeHandler}
                                                        placeholder="Enter Colony"
                                                    />

                                                </div>
                                            </div>

                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label className="form-label">Pincode</label>
                                                    <input
                                                        type="text"
                                                        name="Pincode"
                                                        className="form-control"
                                                        value={formData.Pincode}
                                                        onChange={(e) => {
                                                            const val = e.target.value;
                                                            if (/^\d{0,6}$/.test(val)) {
                                                                onChangeHandler(e);
                                                            }
                                                        }}
                                                        placeholder="Enter Pincode"
                                                        maxLength="6"
                                                    />


                                                </div>
                                            </div>

                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label className="form-label">ExpiredDate</label>
                                                    <input
                                                        type="date"
                                                        name="ExpiredDate"
                                                        className="form-control"
                                                        value={formData.ExpiredDate}
                                                        onChange={onChangeHandler}
                                                        placeholder="Select Expiry date"
                                                    />


                                                </div>
                                            </div>


                                        </>
                                    )}
                                    <DialogActions>
                                        <Button onClick={handleClose} color="primary">
                                            Cancel
                                        </Button>
                                        <Button
                                            onClick={handleSubmit}
                                            variant="contained"
                                            color="primary"
                                            type="submit"
                                        >
                                            {isEditMode ? "Update" : "Add"}
                                        </Button>
                                    </DialogActions>
                                </form>
                            </DialogContent>
                        </Dialog>
                    </div>
                </>
            )}
        </>
    );
}

const shimmerStyle = `
     @keyframes shimmer {
    0% {
      background-position: -468px 0;
    }
    100% {
      background-position: 468px 0;
    }
  }

  .shimmer {
    animation-duration: 1.0s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: shimmer;
    animation-timing-function: linear;
    background:	#F7F7F7;
    background: linear-gradient(to right, #f0f0f0 8%, #fafafa 18%, #f0f0f0 33%);
    background-size: 1000px 104px;
    position: relative;
    overflow: hidden;
  }

  .shimmer-container {
    background-color: 	#F7F7F7;
    border-radius: 4px;
    height: 50px;
    width: 100%;
    margin: 15px;
  }

  .shimmer-text2 {
    background-color: #C8C8C8;
    border-radius: 4px;
    height: 15px;
    width: 55%;
    margin: 15px 0 0 15px;
     position:relative;
     left:10%;
     bottom:10%;
  }
  .shimmer-text {
    background-color: #C8C8C8;
    border-radius: 4px;
    height: 15px;
    width: 15%;
    margin: 15px 0 0 15px;
     
  }
 .shimmer-row {
    display: flex;
  }

  .shimmer-cell {
    flex: 1;
    padding: 10px;
    height: 50px;
    background-color: #F7F7F7;
    border-radius: 4px;
    margin: 5px;
  }
  
  `;
